import React, { useState } from "react";
import { Input, Modal } from "@tyrannosaurustech/ui";
import User from "../../../classes/User";
import { ParagraphS } from "../../../components/atoms/Typography";
import { useGenerateUserResetPasswordLinkMutation } from "../../../redux/reduxQuery/usersApi";
import { useMutationWrapper } from "../../../common/api";
import { CopyButton } from "../../../components/molecules/CopyButton";

interface ResetUserPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: User;
}

export const ResetUserPasswordModal: React.FC<ResetUserPasswordModalProps> = ({
  isOpen,
  onClose,
  user,
}) => {
  const [resetPasswordLink, setResetPasswordLink] = useState("");
  const [generateUserResetPasswordLink, { isLoading }] =
    useGenerateUserResetPasswordLinkMutation();

  const mutateGenerateUserResetPasswordLink = useMutationWrapper(
    generateUserResetPasswordLink,
    () => {
      return `Reset password link copied to clipboard.`;
    },
    (link) => {
      setResetPasswordLink(link);
      navigator.clipboard.writeText(link);
    }
  );

  const onSubmit = () => {
    mutateGenerateUserResetPasswordLink(user);
  };

  return (
    <Modal
      swapButtons
      onConfirm={() => onSubmit()}
      open={isOpen}
      title="Reset Password Link"
      confirmText={resetPasswordLink ? "Regenerate Link" : "Generate Link"}
      cancelText={resetPasswordLink ? "Dismiss" : undefined}
      setOpen={() => {
        onClose();
        setResetPasswordLink("");
      }}
      loading={isLoading}
      buttonAlignment="right"
      titleClassName="text-left font-bold text-xl font-semibold not-italic capitalize"
      panelClassName="w-[600px] max-w-[1000px]"
    >
      <div className="py-5">
        <ParagraphS>
          {resetPasswordLink
            ? `Reset password link for ${user.email} copied to your clipboard.`
            : `Generate a one time reset password link for ${user.email}?`}
        </ParagraphS>
        <div className="flex flex-col gap-4 mt-4">
          <div className="flex w-full items-center space-x-2">
            <div className="flex-grow">
              <Input
                key={resetPasswordLink}
                name="reset-password-link"
                placeholder="Generate Reset Password Link"
                className="w-full"
                disabled
                defaultValue={resetPasswordLink}
              />
            </div>
            {resetPasswordLink && <CopyButton textToCopy={resetPasswordLink} />}
          </div>
        </div>
      </div>
    </Modal>
  );
};
